var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "#1C191A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7744 18.1502L17.6713 19.0234C17.6212 18.9983 15.5874 17.7171 15.5874 17.7171C15.5874 17.2449 15.9095 16.5668 16.4401 16.4745L16.1734 16.1097C16.4619 15.7016 16.8889 15.4122 17.3749 15.2956L18.5104 16.7321C18.6576 16.2299 18.9542 15.7846 19.3608 15.4552C19.6359 15.3834 19.9021 15.281 20.1543 15.1498C20.2623 15.5796 20.3913 15.902 20.4183 16.2442C20.4663 16.8396 20.4558 18.1162 20.2541 18.6202C20.2997 18.8049 20.815 21.0074 18.9727 21.0096H15.7197C15.4866 20.0717 15.5533 19.0868 15.7744 18.1502Z",
    fill: "#2D825F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6709 6.83692H9.43146V4.08256H14.6709V6.83692Z",
    fill: "#2D825F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5692 9.35619H13.672C13.7561 9.35619 13.8367 9.38958 13.8961 9.44902C13.9555 9.50844 13.9889 9.58906 13.9889 9.67311C13.9889 9.75717 13.9555 9.83777 13.8961 9.89721C13.8367 9.95664 13.7561 9.99003 13.672 9.99003H10.5689C10.4849 9.99003 10.4043 9.95664 10.3449 9.89721C10.2854 9.83777 10.252 9.75717 10.252 9.67311C10.252 9.58906 10.2854 9.50844 10.3449 9.44902C10.4043 9.38958 10.4849 9.35619 10.5689 9.35619H10.5692Z",
    fill: "#2D825F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.939 11.1213H20.8086C20.8927 11.1213 20.9733 11.0879 21.0327 11.0284C21.0922 10.969 21.1255 10.8884 21.1255 10.8043C21.1255 10.7203 21.0922 10.6397 21.0327 10.5803C20.9733 10.5208 20.8927 10.4874 20.8086 10.4874H18.939C18.855 10.4874 18.7744 10.5208 18.7149 10.5803C18.6555 10.6397 18.6221 10.7203 18.6221 10.8043C18.6221 10.8884 18.6555 10.969 18.7149 11.0284C18.7744 11.0879 18.855 11.1213 18.939 11.1213Z",
    fill: "#2D825F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34793 9.142H3.53077C3.48865 9.14118 3.44677 9.14876 3.40765 9.16433C3.36841 9.17988 3.33277 9.20309 3.30265 9.2326C3.27265 9.2621 3.24877 9.2973 3.23245 9.33616C3.21613 9.37501 3.20773 9.41672 3.20773 9.45886C3.20773 9.501 3.21613 9.54271 3.23245 9.58157C3.24877 9.62041 3.27265 9.65562 3.30265 9.68513C3.33277 9.71462 3.36841 9.73784 3.40765 9.7534C3.44677 9.76895 3.48865 9.77654 3.53077 9.77572H5.34793C5.39005 9.77654 5.43193 9.76895 5.47105 9.7534C5.51029 9.73784 5.54593 9.71462 5.57605 9.68513C5.60605 9.65562 5.62993 9.62041 5.64625 9.58157C5.66257 9.54271 5.67097 9.501 5.67097 9.45886C5.67097 9.41672 5.66257 9.37501 5.64625 9.33616C5.62993 9.2973 5.60605 9.2621 5.57605 9.2326C5.54593 9.20309 5.51029 9.17988 5.47105 9.16433C5.43193 9.14876 5.39005 9.14118 5.34793 9.142Z",
    fill: "#2D825F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9263 14.6754L19.6048 14.9308C19.6048 14.8761 19.6002 14.8214 19.5979 14.7622C19.7113 14.7507 19.822 14.7214 19.9263 14.6754Z",
    fill: "#C6E84F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4014 13.8138C21.4425 13.9551 21.6414 14.7646 20.9728 15.1886C21.0366 15.2159 21.3536 15.4395 21.3808 15.46C21.6672 15.6717 21.9169 15.9288 22.12 16.2213C22.5372 16.8483 22.5874 17.7876 21.9467 18.2871C21.5226 18.6153 20.752 18.6428 20.3484 18.2511C20.4434 17.5875 20.4663 16.9156 20.4168 16.2471C20.3895 15.8958 20.2618 15.595 20.1843 15.2711C20.0087 14.5455 20.1249 14.356 20.2869 13.9511C20.5947 13.876 20.4852 13.5112 20.2732 13.6342C20.2435 13.6536 20.2101 13.6668 20.1752 13.6731C20.0589 13.0803 19.8332 13.0371 19.628 13.2284C19.9212 12.8433 21.118 12.8454 21.4014 13.8138Z",
    fill: "#C6E84F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8542 17.8811C17.4456 18.894 17.5735 18.9723 17.6759 19.0234L15.7789 18.1502L15.8542 17.8811Z",
    fill: "#C6E84F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11681 20.8155C9.52037 20.4735 10.1128 20.0585 10.6421 19.9035C11.1219 20.0415 11.6307 20.0415 12.1104 19.9035C12.2043 20.1708 12.264 20.4491 12.2883 20.7315C12.2912 20.7652 12.2868 20.799 12.2759 20.8311C12.2649 20.863 12.2474 20.8924 12.2244 20.9172C12.2015 20.9421 12.1737 20.9619 12.1426 20.9753C12.1116 20.9888 12.0782 20.9956 12.0443 20.9955C11.1255 20.9978 10.3275 21.0075 9.18748 21.0093C9.16492 21.0094 9.14285 21.0026 9.12425 20.9897C9.10577 20.9768 9.0916 20.9585 9.08392 20.9373C9.07624 20.916 9.07517 20.893 9.08105 20.8712C9.08693 20.8493 9.09941 20.8299 9.11681 20.8155Z",
    fill: "#C6E84F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36484 18.0635C6.36652 18.0418 6.37492 18.021 6.38896 18.0044C6.403 17.9876 6.42184 17.9756 6.44296 17.97C6.46408 17.9645 6.4864 17.9657 6.5068 17.9735C6.5272 17.9813 6.54472 17.9952 6.55684 18.0134C6.89884 18.417 7.3138 19.3746 7.46884 19.9035C7.33684 20.4098 7.32748 20.535 7.46656 21.0094H6.37456C6.28 21.0184 6.196 19.0053 6.36484 18.0635Z",
    fill: "#C6E84F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84271 4.59556C5.84271 4.65643 5.82466 4.71594 5.79084 4.76656C5.75702 4.81717 5.70895 4.85663 5.6527 4.87992C5.59646 4.90323 5.53458 4.90932 5.47486 4.89744C5.41515 4.88556 5.36031 4.85625 5.31727 4.8132C5.27422 4.77016 5.24491 4.71532 5.23303 4.65561C5.22115 4.59589 5.22724 4.53401 5.25054 4.47777C5.27384 4.42152 5.3133 4.37345 5.36391 4.33963C5.41453 4.30581 5.47404 4.28776 5.53491 4.28776C5.61654 4.28779 5.69481 4.32023 5.75252 4.37795C5.81024 4.43566 5.84268 4.51393 5.84271 4.59556Z",
    fill: "#C6E84F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6777 19.2059L15.519 19.7736C15.3463 19.5878 15.1863 19.3905 15.04 19.1831C15.0425 19.1853 14.9034 19.1898 14.6777 19.2059Z",
    fill: "#C6E84F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.313 14.6412C18.9747 14.884 18.5687 15.0141 18.1524 15.0132H16.7364",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6467 15.0129H16.1004",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5623 15.013H6.07299C5.81127 15.0131 5.55207 14.9616 5.31027 14.8616C5.06847 14.7614 4.84875 14.6146 4.66371 14.4296C4.47867 14.2445 4.33191 14.0248 4.23171 13.783C4.13163 13.5412 4.08015 13.282 4.08027 13.0203V12.4547",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0836 8.62433V5.27046C20.0837 5.00875 20.0323 4.7496 19.9321 4.5078C19.832 4.26601 19.6852 4.0463 19.5002 3.86126C19.315 3.67621 19.0954 3.52943 18.8536 3.42934C18.6118 3.32924 18.3526 3.27776 18.0909 3.27786H6.01146C5.74975 3.27776 5.4906 3.32924 5.2488 3.42934C5.00699 3.52943 4.78728 3.67621 4.60223 3.86126C4.41716 4.0463 4.27038 4.26601 4.17026 4.5078C4.07015 4.7496 4.01865 5.00875 4.01874 5.27046V8.62433",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1451 12.9996V12.4547",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2546 18.62C20.2978 18.4984 20.3299 18.3732 20.3506 18.2459",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.008 15.4278C19.8372 15.4805 19.6703 15.5453 19.5087 15.6216C19.3303 15.7127 19.1839 15.8559 19.0887 16.032C18.7912 16.5822 18.4662 17.1172 18.1151 17.6349L16.4439 16.4721C16.127 16.5269 15.8912 16.7829 15.7576 17.0627C15.6553 17.2654 15.5985 17.4879 15.5912 17.7147C15.7156 17.795 17.2907 18.7956 17.5223 18.9369C18.3051 19.4142 18.915 19.2501 19.36 18.4467C19.4307 18.319 20.0964 17.2451 20.0964 17.2451",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6048 14.9308L19.9263 14.6754C19.8213 14.7214 19.7097 14.7507 19.5957 14.7621",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3576 17.2679C18.4315 16.9551 18.5322 16.6492 18.6586 16.3536C18.9646 15.6926 19.4076 15.4517 19.5204 15.3071C19.5934 15.1961 19.6233 15.0623 19.6044 14.9308L19.5953 14.7621C19.5416 14.7666 19.4875 14.758 19.4378 14.737C19.3882 14.7159 19.3444 14.683 19.3103 14.6412C19.0672 14.3324 19.3217 13.5149 19.6272 13.2276",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6276 13.2276C19.8328 13.0356 20.0585 13.0796 20.1748 13.6724C20.2098 13.6661 20.2431 13.6529 20.2728 13.6335C20.485 13.5106 20.5943 13.8752 20.2865 13.9504C20.2192 14.0823 20.1679 14.2217 20.1338 14.3658C20.0717 14.6668 20.089 14.9787 20.1839 15.2709C20.2618 15.5949 20.3879 15.8957 20.4165 16.2468C20.4655 16.9154 20.4426 17.5872 20.3481 18.2508C20.7516 18.643 21.5228 18.6164 21.9464 18.2868C22.588 17.7887 22.5377 16.8478 22.12 16.2213C21.9179 15.9281 21.6682 15.6708 21.3813 15.4599C21.354 15.4391 21.037 15.2158 20.9733 15.1884C21.6413 14.7644 21.4431 13.955 21.4019 13.8137C21.2111 13.1591 20.6086 12.9513 20.1456 12.9951C19.9491 13.0013 19.7629 13.0848 19.6276 13.2276Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5722 19.824C15.283 19.5675 14.7114 18.7224 14.5021 18.396C14.0769 18.9687 13.1593 19.3469 12.115 19.903",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6421 19.9058C11.4313 19.5563 13.2265 17.4638 13.6722 16.9647C13.8783 16.7344 14.1579 16.5828 14.4634 16.5359",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.781 18.1511L17.6759 19.0234",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8519 17.8811C15.5639 18.9106 15.4617 19.9722 15.7199 21.0094H18.9732C20.8976 21.0094 20.2523 18.6084 20.2523 18.6084C19.928 18.6353 19.6017 18.6284 19.2788 18.5879",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6421 19.9035C10.1131 20.0585 9.52225 20.4758 9.11677 20.8155C9.09937 20.8299 9.08689 20.8493 9.08089 20.8712C9.07501 20.893 9.07597 20.9162 9.08377 20.9374C9.09145 20.9586 9.10561 20.9769 9.12421 20.9898C9.14269 21.0027 9.16489 21.0095 9.18745 21.0094C10.3275 21.0082 11.1255 20.9974 12.0443 20.9956C12.078 20.9957 12.1115 20.9888 12.1425 20.9752C12.1734 20.9618 12.2013 20.942 12.2242 20.9171C12.2471 20.8923 12.2646 20.863 12.2757 20.8311C12.2867 20.7992 12.291 20.7653 12.2883 20.7316C12.2632 20.4494 12.2034 20.1713 12.1104 19.9036C11.6307 20.0416 11.1219 20.0415 10.6421 19.9035Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46799 19.9035C7.31295 19.3745 6.89571 18.4188 6.55599 18.0134C6.54387 17.9952 6.52635 17.9814 6.50595 17.9738C6.48555 17.966 6.46323 17.9648 6.44223 17.9703C6.42111 17.9758 6.40227 17.9878 6.38823 18.0045C6.37419 18.0212 6.36579 18.0418 6.36399 18.0635C6.19407 19.005 6.27999 21.0185 6.37311 21.0094H7.46511C7.32699 20.5352 7.33599 20.4096 7.46799 19.9035Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.468 19.9035C8.8246 19.9833 10.1424 19.7963 11.0544 19.6395",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0334 16.3239C14.7073 16.2419 14.4373 16.383 14.4565 16.5086C14.4606 16.534 14.4703 16.5582 14.4848 16.5795C14.4993 16.6008 14.5184 16.6186 14.5405 16.6317",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0676 16.1255C14.7256 16.0389 14.379 16.2053 14.525 16.3877",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6216 17.4593C15.4072 17.1689 15.1136 16.9466 14.776 16.8186",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0425 16.5587C14.7256 16.4903 14.5135 16.6089 14.5249 16.7343C14.5386 16.8848 14.8369 17.1197 15.0949 16.9782",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16.235 16.5359C16.089 16.3854 15.2973 15.7124 15.2432 15.7653C15.1832 15.824 15.3184 16.0139 15.3184 16.0139",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.235 16.5359C15.9827 16.3292 15.6996 16.1631 15.3959 16.0439C15.0212 15.8975 14.6544 15.7317 14.297 15.547C14.189 15.4834 14.338 15.8183 14.9034 16.1009",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6709 5.69909H20.0836",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01874 5.69909H9.43146",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84274 4.59556C5.84274 4.65643 5.8247 4.71594 5.79087 4.76656C5.75705 4.81717 5.70898 4.85663 5.65274 4.87992C5.59649 4.90323 5.53461 4.90932 5.47489 4.89744C5.41518 4.88556 5.36034 4.85625 5.3173 4.8132C5.27426 4.77016 5.24494 4.71532 5.23306 4.65561C5.22118 4.59589 5.22727 4.53401 5.25057 4.47777C5.27387 4.42152 5.31333 4.37345 5.36394 4.33963C5.41456 4.30581 5.47407 4.28776 5.53494 4.28776C5.61657 4.28779 5.69484 4.32023 5.75255 4.37795C5.81027 4.43566 5.84271 4.51393 5.84274 4.59556Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77524 4.59556C6.77524 4.65643 6.75719 4.71594 6.72336 4.76656C6.68955 4.81717 6.64147 4.85663 6.58523 4.87992C6.52899 4.90323 6.4671 4.90932 6.40739 4.89744C6.34768 4.88556 6.29284 4.85625 6.24979 4.8132C6.20675 4.77016 6.17743 4.71532 6.16555 4.65561C6.15367 4.59589 6.15977 4.53401 6.18306 4.47777C6.20637 4.42152 6.24582 4.37345 6.29644 4.33963C6.34705 4.30581 6.40656 4.28776 6.46744 4.28776C6.54906 4.28779 6.62734 4.32023 6.68505 4.37795C6.74277 4.43566 6.7752 4.51393 6.77524 4.59556Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71234 4.59556C7.71234 4.65643 7.69429 4.71594 7.66047 4.76656C7.62665 4.81717 7.57858 4.85663 7.52233 4.87992C7.46609 4.90323 7.40421 4.90932 7.34449 4.89744C7.28478 4.88556 7.22994 4.85625 7.1869 4.8132C7.14384 4.77016 7.11454 4.71532 7.10266 4.65561C7.09078 4.59589 7.09687 4.53401 7.12017 4.47777C7.14347 4.42152 7.18291 4.37345 7.23354 4.33963C7.28416 4.30581 7.34367 4.28776 7.40454 4.28776C7.48617 4.28779 7.56444 4.32023 7.62215 4.37795C7.67987 4.43566 7.71231 4.51393 7.71234 4.59556Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.515 16.7298L17.3795 15.2934C16.8929 15.41 16.4651 15.6992 16.1757 16.1074L16.4447 16.4722",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1711 15.3161C16.0229 14.6823 15.8979 14.1761 15.8701 14.0211C15.7937 13.5946 15.9061 13.6042 16.0753 13.9641C16.3098 14.503 16.6555 14.9864 17.0899 15.3822",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8975 14.1489C15.7808 14.0382 15.6496 13.9439 15.5076 13.8684C15.4665 13.8503 15.3957 13.8755 15.5737 14.0844C15.6921 14.2236 15.9089 14.5044 16.0092 14.6408",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1392 15.1698C16.0038 15.1342 15.8706 15.0908 15.7402 15.0398C15.5785 14.9867 15.426 14.9298 15.763 15.2586C15.969 15.4636 16.1574 15.6855 16.3261 15.9221",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.684 11.3399C10.6895 11.2815 10.7147 11.2265 10.7555 11.1843C10.7963 11.142 10.8503 11.1148 10.9085 11.1072L13.2618 10.7447C13.3827 10.7265 13.4778 10.7927 13.4761 10.8953L13.4533 12.7877L14.9878 13.8018C15.079 13.8588 15.0265 13.9979 14.8989 14.0344L12.514 14.7064C12.4826 14.7171 12.4493 14.7204 12.4164 14.716C12.3835 14.7117 12.3522 14.6998 12.3247 14.6813L10.6843 13.4159L10.684 11.3399Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6843 13.4169L13.4533 12.7877",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0046 13.0635C10.9636 13.0727 10.9236 13.0521 10.9236 13.0155V11.4515C10.9249 11.4326 10.9329 11.4146 10.9459 11.4009C10.9591 11.3871 10.9767 11.3784 10.9956 11.3763L13.1479 11.0343C13.156 11.0319 13.1644 11.0314 13.1726 11.0328C13.1808 11.0342 13.1886 11.0374 13.1954 11.0422C13.2022 11.047 13.2079 11.0534 13.2119 11.0607C13.2159 11.068 13.2182 11.0762 13.2186 11.0844L13.2049 12.5027C13.2029 12.5206 13.1951 12.5374 13.1828 12.5505C13.1705 12.5637 13.1543 12.5724 13.1365 12.5757L11.0046 13.0635Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.618 12.4547H21.8597V8.62433H16.618V12.4547Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4579 12.4547H14.7324V8.62433H9.49298V12.4547H10.6809",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60742 12.4547H2.36798V8.62433H7.60742V12.4547Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6709 6.83692H9.43146V4.08256H14.6709V6.83692Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0512 6.83692V8.62432",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4397 6.83692V7.73056H19.1762V8.62432",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7539 6.83692V7.73056H4.92618V8.62432",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5769 5.97496L10.4939 5.43472L11.5632 4.92388",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 5.97952L13.6084 5.43004L12.5254 4.92844",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4205 4.47712L11.6681 6.44236",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7055 9.99004C17.6634 9.99087 17.6215 9.98327 17.5824 9.96772C17.5432 9.95217 17.5075 9.92896 17.4775 9.89945C17.4474 9.86995 17.4235 9.83474 17.4072 9.79589C17.3908 9.75704 17.3824 9.71533 17.3824 9.67318C17.3824 9.63105 17.3908 9.58934 17.4072 9.55048C17.4235 9.51164 17.4474 9.47643 17.4775 9.44692C17.5075 9.41741 17.5432 9.39421 17.5824 9.37865C17.6215 9.3631 17.6634 9.35551 17.7055 9.35632H20.8063C20.8485 9.35551 20.8903 9.3631 20.9295 9.37865C20.9687 9.39421 21.0043 9.41741 21.0344 9.44692C21.0645 9.47643 21.0884 9.51164 21.1047 9.55048C21.121 9.58934 21.1294 9.63105 21.1294 9.67318C21.1294 9.71533 21.121 9.75704 21.1047 9.79589C21.0884 9.83474 21.0645 9.86995 21.0344 9.89945C21.0043 9.92896 20.9687 9.95217 20.9295 9.96772C20.8903 9.98327 20.8485 9.99087 20.8063 9.99004H17.7055Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5692 9.35621C10.4852 9.35621 10.4045 9.38959 10.3451 9.44903C10.2856 9.50847 10.2522 9.58907 10.2522 9.67313C10.2522 9.75718 10.2856 9.83778 10.3451 9.89722C10.4045 9.95665 10.4852 9.99005 10.5692 9.99005H13.672C13.7561 9.99005 13.8367 9.95665 13.8961 9.89722C13.9555 9.83778 13.9889 9.75718 13.9889 9.67313C13.9889 9.58907 13.9555 9.50847 13.8961 9.44903C13.8367 9.38959 13.7561 9.35621 13.672 9.35621H10.5692Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.939 10.4874C18.8547 10.4877 18.7739 10.5215 18.7145 10.5813C18.6551 10.6411 18.6218 10.7221 18.6221 10.8064C18.6221 10.8479 18.6303 10.8891 18.6462 10.9274C18.6621 10.9658 18.6855 11.0006 18.715 11.0298C18.7444 11.0591 18.7794 11.0823 18.8179 11.098C18.8563 11.1137 18.8975 11.1216 18.939 11.1213H20.8063C20.8904 11.1213 20.971 11.0879 21.0304 11.0285C21.0899 10.969 21.1233 10.8884 21.1233 10.8044C21.1233 10.7203 21.0899 10.6397 21.0304 10.5803C20.971 10.5208 20.8904 10.4874 20.8063 10.4874H18.939Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34793 9.142C5.39005 9.14118 5.43193 9.14876 5.47105 9.16433C5.51029 9.17988 5.54593 9.20309 5.57605 9.2326C5.60605 9.2621 5.62993 9.2973 5.64625 9.33616C5.66257 9.37501 5.67097 9.41672 5.67097 9.45886C5.67097 9.501 5.66257 9.54271 5.64625 9.58157C5.62993 9.62041 5.60605 9.65562 5.57605 9.68513C5.54593 9.71462 5.51029 9.73784 5.47105 9.7534C5.43193 9.76895 5.39005 9.77654 5.34793 9.77572H3.53077C3.48865 9.77654 3.44677 9.76895 3.40765 9.7534C3.36841 9.73784 3.33277 9.71462 3.30265 9.68513C3.27265 9.65562 3.24877 9.62041 3.23245 9.58157C3.21613 9.54271 3.20773 9.501 3.20773 9.45886C3.20773 9.41672 3.21613 9.37501 3.23245 9.33616C3.24877 9.2973 3.27265 9.2621 3.30265 9.2326C3.33277 9.20309 3.36841 9.17988 3.40765 9.16433C3.44677 9.14876 3.48865 9.14118 3.53077 9.142H5.34793Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20521 10.2728C6.28825 10.2744 6.36721 10.3085 6.42541 10.3678C6.48349 10.427 6.51613 10.5067 6.51613 10.5897C6.51613 10.6728 6.48349 10.7525 6.42541 10.8117C6.36721 10.871 6.28825 10.9051 6.20521 10.9067H3.53077C3.44773 10.9051 3.36877 10.871 3.31057 10.8117C3.25249 10.7525 3.21985 10.6728 3.21985 10.5897C3.21985 10.5067 3.25249 10.427 3.31057 10.3678C3.36877 10.3085 3.44773 10.2744 3.53077 10.2728H6.20521Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5167 7.23352L10.7584 6.83692L10.9841 7.24492",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8118 7.23352L12.0534 6.83692L12.2769 7.24492",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2071 7.23352L13.4488 6.83692L13.6722 7.24492",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4265 6.86188L20.608 7.67356",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4243 7.67585L20.6103 6.85973",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73737 7.12864L3.09761 7.63708L3.51941 6.90064",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3631 15.4553C19.6382 15.3833 19.9043 15.2808 20.1566 15.1497",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0694 1.15504L12.5414 1.31008L12.2678 1.55632L12.628 1.95988L12.4342 2.13316L12.074 1.7296L11.8004 1.97356L11.5974 1L12.0694 1.15504Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77798 16.5359C9.77798 16.5688 9.7877 16.601 9.80606 16.6284C9.8243 16.6558 9.85034 16.677 9.8807 16.6896C9.91118 16.7022 9.94466 16.7056 9.97694 16.6991C10.0092 16.6928 10.0389 16.6769 10.0621 16.6536C10.0854 16.6304 10.1013 16.6007 10.1076 16.5684C10.1141 16.5362 10.1107 16.5027 10.0981 16.4722C10.0855 16.4418 10.0643 16.4158 10.0369 16.3976C10.0095 16.3792 9.9773 16.3695 9.94442 16.3695C9.90038 16.3697 9.85814 16.3874 9.82706 16.4186C9.79586 16.4496 9.77822 16.4919 9.77798 16.5359Z",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 21.0093H0.999988",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6777 19.2059L15.5213 19.7759",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0425 19.1853C14.3946 19.2153 13.7491 19.2831 13.1091 19.3883",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5021 18.3965L14.6549 18.1752",
    stroke: "white",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.3faabc318c63fbdf11ff1bead8cb68db.svg";
export { ForwardRef as ReactComponent };